import cn from 'classnames';
import styles from './styles.scss';

interface OwnProps {
  day: Date;
  selectDate: (date: Date) => void;
  currentDay: boolean;
  showIsDaySelected?: boolean;
}

export const SelectableDay = ({ day, selectDate, currentDay, showIsDaySelected }: OwnProps) => {
  return (
    <a
      onClick={() => selectDate(day)}
      className={cn(styles.day, {
        [styles.currentDay]: currentDay,
        [styles.selected]: showIsDaySelected
      })}
    >
      {day.getDate()}
    </a>
  );
};
